import React from 'react';
import { Anchor, Paragraph, Popover, Popper, Tag } from '@zillow/constellation';
import { EXPERIAN_IDENTITY_MANAGEMENT_URL } from '../../constants/urls';

const VERIFICATION_EXPIRED_TEXT = 'Identity Verification Expired';

export default function IdVerificationExpiredTag() {
  return (
    <>
      <Tag appearance="gray">{VERIFICATION_EXPIRED_TEXT}</Tag>
      <Popper
        triggered={
          <Popover
            renderCloseButton={false}
            body={
              <Paragraph>
                This renter’s identity has previously been verified by{' '}
                <Anchor href={EXPERIAN_IDENTITY_MANAGEMENT_URL} target="_blank">
                  Experian
                </Anchor>
                , but that verification has now expired. We recommend you review the applicant’s government-issued ID or
                other documentation before making a leasing decision.
              </Paragraph>
            }
          />
        }
      />
    </>
  );
}
